import React, { lazy } from 'react';
import { ProtectedRoute } from '@components';

const Record = lazy(() => import('./record'));

export default {
  path: 'contract',
  element: <ProtectedRoute title="电子合同" component={<Record />} />,
};
